import { addCopilotContext as e, addCopilotInstruction as t, addCopilotTool as n } from "../global-state.js";
import { useCallback as r, useEffect as i, useRef as a } from "react";
//#region src/react/global-state.ts
function o(e) {
	let n = e.isEnabled ?? !0;
	return i(() => {
		if (n === !1) return;
		let r = t(e);
		return () => r();
	}, [n, e.instruction]);
}
function s(e) {
	let t = e.isEnabled ?? !0, r = "handler" in e ? e.handler : void 0, o = a(r);
	o.current = r;
	let s = r != null, c = a(e.render);
	c.current = e.render;
	let l = e.render != null, u = a(e.needsApproval);
	u.current = e.needsApproval;
	let d = e.needsApproval != null, f = e.humanInTheLoop === !0;
	return i(() => {
		if (t === !1) return;
		let r = {
			name: e.name,
			description: e.description,
			requestSchema: e.requestSchema,
			responseSchema: e.responseSchema,
			needsApproval: d ? (e) => typeof u.current == "function" ? u.current(e) : u.current === !0 : void 0,
			render: l ? (e) => c.current?.(e) : void 0
		}, i = n(e.type === "client" ? f ? {
			...r,
			type: e.type,
			humanInTheLoop: !0,
			render: (e) => c.current?.(e)
		} : {
			...r,
			type: e.type,
			handler: (e) => o.current?.(e)
		} : {
			...r,
			type: e.type,
			handler: (e) => o.current?.(e),
			isStreaming: e.isStreaming
		});
		return () => i();
	}, [
		t,
		e.type,
		e.name,
		e.description,
		e.requestSchema,
		e.responseSchema,
		d,
		f,
		"isStreaming" in e ? e.isStreaming : !1,
		s,
		l
	]);
}
function c(t) {
	let n = t.isEnabled ?? !0, o = a(t);
	o.current = t;
	let s = r(() => typeof o.current.value == "function" ? o.current.value() : o.current.value, []);
	return i(() => {
		if (n === !1) return;
		let r = e({
			description: t.description,
			value: s
		});
		return () => r();
	}, [n, t.description]);
}
//#endregion
export { c as useCopilotContext, o as useCopilotInstruction, s as useCopilotTool };
